/**
 * Creates an array of product attributes
 * @param {Object} product
 */
function setAttributes(product) {
  const attributes = [
    {
      key: '_short_description',
      value: product.subtitle,
    },
    {
      key: '_product_tags',
      value: product.tags.join(','),
    },
    {
      key: '_cart_drawer_item_body_promo_badge',
      value: product.cartDrawerItemBodyPromoBadge,
    },
  ];
  if (product.variants[0].compareAtPrice) {
    attributes.push({
      key: '_compare_price',
      value: product.variants[0].compareAtPrice?.amount,
    });
  }
  return attributes.filter((el) => el.value);
}

export default setAttributes;
